export const defaultValues = {
  password: '',
  otherReason: '',
  reason: null,
};

export const reasonList = [
  "The features don't meet my expectation",
  'I have concerns about my privacy',
  "I'm not using Session Studio enough",
  'Other',
];

export const deleteAccountRulesList = [
  {
    label:
      'Any audio you uploaded to a Song and set as Private will be deleted, but if the audio is set to available to other Collaborators the audio will remain in the Songs',
    id: 'index-1',
  },
  {
    label: 'Any audio share links you have created will be deleted',
    id: 'index-2',
  },
  {
    label:
      'All the credits you have been given (e.g. as songwriter, musician etc.) will remain, in order to make sure that if a registration is made by your collaborators it will be correct and you still get the credits you deserve',
    id: 'index-3',
  },
  {
    label: 'Any ongoing premium subscription will not be renewed',
    id: 'index-4',
  },
];
